import { useEffect, useState } from 'react';

/**
 * Reports whether the device can hover with a fine pointer (mouse / trackpad).
 *
 * Resolved inside an effect and therefore `undefined` during the first render, which keeps server
 * and client markup identical. Callers should treat `undefined` like the hover-capable default.
 */
export function useHoverCapable(): boolean | undefined {
  const [isHoverCapable, setIsHoverCapable] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (globalThis.window === undefined || typeof globalThis.matchMedia !== 'function') {
      setIsHoverCapable(false);
      return;
    }

    setIsHoverCapable(globalThis.matchMedia('(hover: hover) and (pointer: fine)').matches);
  }, []);

  return isHoverCapable;
}
